import { z } from 'zod';
import { CertificationStatus } from '@/routes/_staff/certification/-constants';
import { SpecialtyCertificationTableColumns } from './-constants';
export const SpecialtyCertificationTableFilterSchema = z.object({
  // ページネーション
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100),
  // ソート
  sortColumn: z.nativeEnum(SpecialtyCertificationTableColumns).optional(),
  sortOrder: z.enum(['asc', 'desc']).optional(),
  // タブフィルタ
  certificationStatus: z.nativeEnum(CertificationStatus).optional(),
  // フィルタ
  freeText: z.string().optional()
});
export type SpecialtyCertificationTableFilterType = z.infer<typeof SpecialtyCertificationTableFilterSchema>;